export default function formatDate(date) {
  let result = '';
  if (!date) return result;
  if (typeof date === 'string') result = new Date(date);
  if (date instanceof Date) result = date;
  return result.getDate() + '.' + (result.getMonth() + 1) + '.' + result.getFullYear();
}
